export class ConsoleTransport {
    formatter;
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(formatter) {
        this.formatter = formatter;
    }
    write(appLog) {
        const log = this.formatter.format(appLog);
        switch (appLog.level) {
            case 'fatal':
            case 'error':
                console.error(log);
                return;
            case 'warning':
                console.warn(log);
                return;
            case 'info':
                console.info(log);
                return;
            case 'debug':
                console.debug(log);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(log);
        }
    }
}
//# sourceMappingURL=ConsoleTransport.js.map